import { useEffect } from 'react';
import { useNavigateSoftOrHard } from './useNavigateSoftOrHard';

type UseForceRedirectProps = {
  redirectTo: string | null | undefined;
};

/**
 * @note This function does _not_ support passing paths only (i.e. excluding the host of the domain) since new URL(..)
 * requires passing the base URL if the URL is not a complete URL
 * @see: https://stackoverflow.com/a/74768629
 */
export const useForceRedirect = ({ redirectTo }: UseForceRedirectProps) => {
  const navigate = useNavigateSoftOrHard();

  useEffect(() => {
    if (redirectTo) {
      try {
        const url = new URL(redirectTo);
        navigate(url.toString());
      } catch (e) {
        console.log('Caught error while trying to redirect...');
        console.log(e);
      }
    }
  }, [redirectTo, navigate]);
};
